import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { AuthenticationService } from '@core/services/authentication.serivce';
import { BaseDetailForm } from '@shared/ui/base-detail-form';
import { AuthUser } from '@shared/interfaces/entities/auth-user.interface';
import { UiGroupControl } from '@shared/ui/controls/ui-group-control.model';
import { TextControl } from '@shared/ui/controls/text-control.model';
import { ToggleControl } from '@shared/ui/controls/toggle-control.model';
import { ViewControl } from '@shared/ui/controls/view-control.model';
import { ViewRowControl } from '@shared/ui/controls/view-row-control.model';
import { OrganizationSelect } from '../../../shared/ui/select-controls/organizations-select.model';
import { UploadControl } from '../../../shared/ui/controls/upload-control.model';
import { ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { faRemove, faSearch } from '@fortawesome/free-solid-svg-icons';
import { DetailService } from '../../../core/services/detail.service';
import { UiColumn } from '../../../shared/ui/ui-column';
import { TabOptions } from '../../../shared/interfaces/tab-option.interface';
import { TabControl } from '../../../shared/ui/controls/tab-control.model';
import { Collection } from '../../../shared/interfaces/entities/collection.interface';
import { SelectEvent, FileInfo, RemoveEvent, UploadComponent } from '@progress/kendo-angular-upload';
import { ImageInfo } from '../../../shared/components/upload/upload.component';
import { CollectionService } from '../services/collection.service';
import { CollectionDocument } from '../../../shared/interfaces/entities/collection-document.interface';
import { ImageEntity } from '../../../shared/interfaces/entities/image.interface';
import { ShippingMethodSelect } from '../../../shared/ui/select-controls/shipping-method-select.model';
export interface IFile extends FileInfo {
  image: string;
}

@Component({
    selector: 'app-collection',
    templateUrl: './collection.component.html',
    styleUrls: ['./collection.component.css'],
    standalone: false
})

export class CollectionComponent extends BaseDetailForm<Collection> {

  @ViewChild('kendoUpload') kendoUpload: UploadComponent;
  @Output() submitRequest: EventEmitter<Array<IFile>> = new EventEmitter();

  public files: IFile[] = [];

  id: string;

  itemImageResults: ImageEntity[] = [];

  imageData = [];
  public items: ImageEntity[] = this.imageData;
  public width = "30%";
  public height = "300px";

  isEmpty: boolean;

  uploadSaveUrl = "saveUrl"; // should represent an actual API endpoint
  uploadRemoveUrl = "removeUrl"; // should represent an actual API endpoint

  constructor(private router: ActivatedRoute,
              private auth: AuthenticationService,
              private detailService: DetailService<any>,
              private collectionService: CollectionService) {
    super();
    this.name = "Collection";
    this.apiController = "Collection";
    this.keyFieldName = "id";

    this.router.params.subscribe(params => this.id = params['id']);

    this.initializeUiControls();
  }


  ngOnInit() {
    var session = this.auth.getSession();

    this.collectionService.getCollectionImages(this.id).subscribe((data => {
      this.itemImageResults = data;
      this.items = data;

      if (data.length == 0) { this.isEmpty = true };
    }));
  }

  public onSelect(ev: SelectEvent): void {
    if (this.files && ev.files) {
      ev.files.forEach((file: FileInfo) => {
        if (file.rawFile && !file.validationErrors) {
          const reader = new FileReader();
          reader.onloadend = () => {
            this.files.push({ ...file, image: <string>reader.result });
          };
          reader.readAsText(file.rawFile);
        }
      });
    }
  }

  public onRemove(ev: RemoveEvent): void {
    ev.files.forEach((file: FileInfo) => {
      this.files = this.files.filter((f) => f.uid !== file.uid);
    });
  }

  open(entity: CollectionDocument) {
    var e = window.event;
    e?.preventDefault();
    if (entity) {
      this.collectionService.openDocument(entity.id).subscribe((resp: Blob) => {
        var blobUrl = URL.createObjectURL(resp);
        window.open(blobUrl, "_blank");
      });
    }
  }

  public removeCollection() {
    //This is the collection organization ID 
    this.detailService.remove(this.id, "Collection");
  }

  override initializeUiControls() {

    const detailsView = new ViewControl("Collection Details");

    const userDetails = new UiGroupControl("", "Collection Details");

    const name = new TextControl("name", "Name", "");
    const shippingMethodId = new ShippingMethodSelect("shippingMethodId", "Shipping Method", null);
    const disabled = new ToggleControl("isActive", "Is Active?", null);

    var uRow1 = new ViewRowControl();
    uRow1.controls.push(name, shippingMethodId);

    var uRow2 = new ViewRowControl();
    uRow2.controls.push(disabled);

    userDetails.rows.push(uRow1, uRow2);
    detailsView.controls.push(userDetails);


    var collectionOrganizationColumns: UiColumn[] = [
      new UiColumn("organization_Name", "Organization", 300)
    ];

    var collectionOrganizationOptions: TabOptions = {
      name: "collectionOrganizations",
      label: "Collection Organization",
      columns: collectionOrganizationColumns,
      apiController: "CollectionOrganization",
      showDeleteBtn: true,
      showEditBtn: false,
      editWindowSettings:
      {
        width: 600,
        height: 250
      }
    };

    const collectionOrganizationTab = new TabControl(collectionOrganizationOptions);

    var docColumns: UiColumn[] = [
      new UiColumn("filename", "Name", 350)
    ];

    var docOptions: TabOptions = {
      name: "collectionDocuments",
      label: "Documents",
      columns: docColumns,
      apiController: "CollectionDocument",
      showDeleteBtn: true,
      showEditBtn: true,
      postAsFormData: true,
      defaultValue: {
        keyFieldName: "id",
        foreignKeyFieldName: "collectionId",
        apiController: "Collection",
        values: [
          { field: "collectionId", value: 0, mapping: "id" }
        ]
      },
      actions: [
        {
          text: "Open",
          icon: faSearch,
          hasMultiple: false,
          cssClass: "purpleBg",
          action: (entity: any) => { this.open(entity); }
        }
      ],
      editWindowSettings: {
        height: 350,
        width: 550
      }
    };

    var doc = new TabControl(docOptions);

    //If this is a new Collection - hide the partial view, we can only add a collection organization IF there is a collection saved
    if (Number(this.id) != 0) {
      detailsView.controls.push(collectionOrganizationTab, doc);
    }

    this.views.push(detailsView);

    var session = this.auth.getSession();
    var canEditSettings: boolean = false;
    if (session) {
      canEditSettings = session.userId.toString() == this.id;
    }
  }
}


